import * as React from "react";
import JsonRenderComponent from "../../../../utils/JsonRenderComponent";
import { Alert } from "@material-ui/lab";
import { Element, scroller } from "react-scroll";

interface IProps {
  customer?: any;
  demographicProfile?: any;
  healthProfile?: any;
  heading?: string;
  randomDemographicInfo?: any;
}

function scrollToTopOfResults() {
  try {
    scroller.scrollTo("customer-result", {
      delay: 100, // added small delay, as element isn't mounted yet when the scroll function is called.
      duration: 800,
      offset: -250,
      smooth: "easeInOutQuart",
    });
  } catch (error) {
    console.log("Scroll error:", error);
  }
}

class CustomerResult extends React.Component<IProps> {
  constructor(props: IProps) {
    super(props);
  }

  componentDidMount() {
    if (this.props.customer) {
      scrollToTopOfResults();
    }
  }

  public render() {
    return (
      <div>
        <br />
        {this.props.customer.phoneNumber && <h4>Amazon Customer</h4>}
        {!this.props.customer.phoneNumber &&
          this.props.customer.profile[0].phoneNumber && (
            <h4>{this.props.heading}</h4>
          )}
        <div
          style={{
            border: "3px solid lightgray",
            padding: "5px",
            whiteSpace: "pre-wrap",
            wordBreak: "normal",
            wordWrap: "break-word",
          }}
        >
          {this.props.randomDemographicInfo && (
            <Alert variant="filled" severity="info">
              Please use demographic information of the customer generated below
              to avoid any issues during signup.
            </Alert>
          )}

          {this.props.customer.phoneNumber && (
            <Alert variant="filled" severity="info">
              Please use phone number: '{this.props.customer.phoneNumber}' with
              OTP '112233' when asked on Amazon Pharmacy website. This number
              will also be used for your Amazon profile.
            </Alert>
          )}

          {!this.props.customer.phoneNumber &&
            this.props.customer.profile[0].phoneNumber && (
              <Alert variant="filled" severity="info">
                Please use phone number: '
                {this.props.customer.profile[0].phoneNumber}' with OTP '112233'
                when asked on Amazon Pharmacy website. This number will also be
                used for your Amazon profile.
              </Alert>
            )}

          {!this.props.customer.phoneNumber &&
            this.props.customer.profile[0].scriptChaseInitiated ===
              "In Progress" &&
            this.props.customer.profile[0].healthProfile.primaryDoctor !==
              "None" && (
              <Alert variant="filled" severity="info">
                Please wait for 1 minute before we can see script chase
                initiated for the medication '{this.formatMedicationList()}' on
                customer dashboard.
              </Alert>
            )}

          {!this.props.customer.phoneNumber &&
            this.props.customer.profile[0].scriptChaseCompleted ===
              "In Progress" &&
            this.props.customer.profile[0].healthProfile.primaryDoctor !==
              "None" &&
            (this.props.customer.profile[0].orderCreated === null ||
              this.props.customer.profile[0].orderCreated === "No") && (
              <Alert variant="filled" severity="info">
                Please wait for 1 minute before we can see script chase
                completed with a dispensable prescription '
                {this.formatMedicationList()}' on customer dashboard.
              </Alert>
            )}

          {!this.props.customer.phoneNumber &&
            this.props.customer.profile[0].scriptChaseFaked === "In Progress" &&
            this.props.customer.profile[0].healthProfile.primaryDoctor !==
              "None" && (
              <Alert variant="filled" severity="info">
                Please wait for 1 minute before we can see script chase faked
                with a dispensable prescription '{this.formatMedicationList()}'
                on customer dashboard.
              </Alert>
            )}

          {!this.props.customer.phoneNumber &&
            this.props.customer.profile[0].scriptChaseCompleted ===
              "In Progress" &&
            this.props.customer.profile[0].healthProfile.primaryDoctor !==
              "None" &&
            this.props.customer.profile[0].orderCreated === "In Progress" && (
              <Alert variant="filled" severity="info">
                Please wait for 1 minute before we can see order created with a
                dispensable prescription '{this.formatMedicationList()}' on
                customer dashboard.
              </Alert>
            )}

          <Element name="customer-result" className="element" />
          <JsonRenderComponent
            jsonObject={this.props.customer}
            printHtml={false}
          />
          <JsonRenderComponent
            jsonObject={this.props.randomDemographicInfo}
            printHtml={false}
          />
        </div>
      </div>
    );
  }

  private formatMedicationList(): string {
    const medList = this.props.customer.profile[0].healthProfile.medicationList;
    let formattedString: string = medList[0];

    for (let i = 1; i < medList.length; i++) {
      formattedString = formattedString + "/ " + medList[i];
    }
    return formattedString;
  }
}

export default CustomerResult;
